<section class="plans-catalog" data-testid="plans-catalog">
	@if (productTabs.length > 1) {
	<lo-segmented-tabs
		class="product-tabs"
		label="Product"
		[tabs]="productTabItems"
		[selected]="activeTabId"
		(selectedChange)="onProductTab($event)"
	></lo-segmented-tabs>
	} @if (!loading && showAnnualToggle) {
	<app-plan-interval-toggle
		class="interval-toggle"
		[annually]="annually"
		[savingsPercent]="annualSavings"
		[freeMonths]="annualFreeMonths"
		(annuallyChange)="onToggleAnnually($event)"
	></app-plan-interval-toggle>
	} @if (loading) {
	<ul class="plans" aria-hidden="true" aria-busy="true">
		@for (card of skeletonCards; track card) {
		<app-plan-card-skeleton></app-plan-card-skeleton>
		}
	</ul>
	<app-enterprise-card-skeleton
		aria-hidden="true"
		[wide]="true"
	></app-enterprise-card-skeleton>
	} @if (!loading && scheduledBanner; as banner) {
	<lo-notice
		tone="warning"
		[attr.data-change-type]="banner.changeType"
		[heading]="banner.message"
	>
		<button
			lo-button
			variant="secondary"
			size="sm"
			type="button"
			[loading]="scheduledActionInFlight"
			(click)="cancelScheduledChange()"
		>
			Cancel scheduled change
		</button>
	</lo-notice>
	} @if (!loading && !isCreatorDataApi && activePlanRows.length === 0) {
	<lo-empty-state
		heading="No plans available for this product."
	></lo-empty-state>
	}

	<!-- Creator Data API: selector cards (Report + Quick) instead of one-per-tier. -->
	@if (!loading && isCreatorDataApi) {
	<ul class="plans plans--api">
		@if (reportTiers.length > 0) {
		<app-creator-data-api-card
			title="Report API"
			[features]="reportFeatures"
			[tiers]="reportTiers"
			[contactUrl]="activeEnterprisePlan?.calendly_url"
			(select)="onSelectApiPlanId($event)"
		></app-creator-data-api-card>
		} @if (quickTiers.length > 0) {
		<app-creator-data-api-card
			title="Quick API"
			[features]="quickFeatures"
			[tiers]="quickTiers"
			[contactUrl]="activeEnterprisePlan?.calendly_url"
			(select)="onSelectApiPlanId($event)"
		></app-creator-data-api-card>
		} @if (enterpriseLoading) {
		<app-enterprise-card-skeleton></app-enterprise-card-skeleton>
		} @if (!enterpriseLoading && activeEnterprisePlan) {
		<app-enterprise-card
			[plan]="activeEnterprisePlan"
		></app-enterprise-card>
		}
	</ul>
	} @if (!loading && !isCreatorDataApi && activePlanRows.length > 0) {
	<ul class="plans plans--aligned">
		@for (plan of activePlanRows; track trackByPlanCard($index, plan)) {
		<app-plan-card
			[attr.data-plan-alias]="plan.alias"
			[attr.data-tier]="plan.tier_level"
			[attr.data-action]="plan.action"
			[attr.data-allowance-change]="plan.allowanceChange ? 'true' : null"
			[title]="plan.cardTitle"
			[subtitle]="plan.subtitle"
			[trialKind]="plan.trial_kind"
			[hasTrial]="plan.hasTrial"
			[popular]="
				isPopular(plan) &&
				plan.action !== 'current' &&
				(currentPlanTierLevel === null ||
					currentPlanTierLevel <= plan.tier_level)
			"
			[struckPrice]="plan.struckMonthlyPrice"
			[priceValue]="plan.monthlyPrice"
			priceMeta="/ month"
			[priceNote]="plan.priceNote"
			[featureRows]="plan.featureRows"
			[detailsAvailable]="true"
			(detailsRequested)="onPlanDetails(plan)"
			[ladder]="plan.ladder"
			[ladderIndex]="plan.ladderIndex"
			[ladderLabel]="allowanceDialLabel"
			[ladderFooter]="plan.ladderFooter"
			(ladderIndexChange)="onLadderIndexChange(plan, $event)"
			[actionLabel]="
				plan.actionInFlight ? 'Working...' : plan.actionLabel
			"
			[actionType]="plan.action"
			[actionDisabled]="
				plan.actionInFlight ||
				plan.action === 'current' ||
				plan.action === 'scheduled' ||
				plan.action === 'unavailable'
			"
			[leadingCheck]="plan.action === 'current'"
			[actionNote]="plan.actionNote"
			(action)="onPlanAction(plan)"
		></app-plan-card>
		} @if (enterpriseLoading) {
		<app-enterprise-card-skeleton></app-enterprise-card-skeleton>
		} @if (!enterpriseLoading && activeEnterprisePlan) {
		<app-enterprise-card
			[plan]="activeEnterprisePlan"
			[subtitle]="enterpriseCopy.subtitle"
			[priceNote]="enterpriseCopy.priceNote"
			[dialLabel]="allowanceDialLabel"
			[dialValue]="enterpriseAllowanceLabel"
		></app-enterprise-card>
		}
	</ul>
	}
</section>
